<template>

    <div  class="climate-wrap bg-white ">
        <div class="card-body m-b-0 p-20px"><h4 class="card-title">{{$t('dashBoard.cSysSearchCount.searchCount')}} 
            <!-- <span
                class="font-14 font-normal text-muted">12th April, 2018</span> -->
                </h4>
            <div class="d-flex align-items-center flex-row m-t-30"><h1 class="font-light"><img
                    src="@imgPath/img/svg/icons/search-icon.svg" alt="" class="h-50px"><span
                    class="pl-5px">{{totalCount}}<sup></sup></span></h1></div>
        </div>
        <div class="chart-wrap"  >
            <CChartLineSimple :timeData="timeOptions" :dataPoints="searchCountList" pointed border-color="warning"/>
        </div>

    </div>



</template>
<script>
import Logger from "../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../router/index";
import apiSearchCount from "./../../../services/apiSearchCount";
import CChartLineSimple from "../../chart/CChartLineSimple"
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS } from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import SERVICE_URL from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../util/util";

export default {
  name: COMPONENT_NAME.C_SYS_SEARCH_COUNT,
components:{
    CChartLineSimple
},
  data () {
    return {
        searchCountList:[],
        totalCount: 0,
        timeOptions:[]
    }
   },

   computed: {
           ...mapGetters("sSysLogin", {
      ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
        },
    async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                if (this.ADMIN_SIGNIN_RES) {
                   let searchCountRes = await this.getSearchCount();
                   this.searchCountList = this.toGetSearchCountLs(searchCountRes);

                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_SEARCH_COUNT,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

  methods: {

      showAlert(val) {
                this.$emit("showAlert", val);
            },

      toGetSearchCountLs(pSearchCountRes) {
          let retValue=[];
          try {
            if(BaseConfiguration.isDebug) console.log("toGetSearchCountLs");
            if(pSearchCountRes && pSearchCountRes.SearchCount) {
                for (let i = 0; i < pSearchCountRes.SearchCount.length; i++) {
                    this.totalCount+=Number(pSearchCountRes.SearchCount[i].searchcount);
                    retValue.push(Number(pSearchCountRes.SearchCount[i].searchcount)) 
                    this.timeOptions.push(this.$options.filters.formatDate(pSearchCountRes.SearchCount[i].hour, BaseConfiguration.defaultDateTimeFormat))
                }
            }
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.C_SYS_SEARCH_COUNT,
                    "error in toGetSearchCountLs",
                    err.toString(),
                    "toGetSearchCountLs",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
     }, 

       async getSearchCount() {
                if (BaseConfiguration.isDebug) console.log("getSearchCount");
                let returnValue;
                try {
                    let searchCountReq = apiSearchCount.buildRequest(); //constant

                    if (searchCountReq != null) {
                        let searchCountRes = await apiSearchCount.getResponse(
                            searchCountReq
                        );
                        if (VALIDATE_SUCCESS_RES(searchCountRes)) {
                            returnValue = searchCountRes.data.data;

                        } else {
                            let error = getErrorMessage(searchCountRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_SEARCH_COUNT,
                        "error in  getSearchCount",
                        err.toString(),
                        "getSearchCount()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
  }
}

</script>